/**
 * Kratome — core theme behaviors
 * Mobile menu, FAQ accordion, review carousel, product gallery, sticky
 * add-to-cart visibility. Vanilla JS, no external dependencies.
 */
(function () {
  "use strict";

  /* ------------------------------- Mobilmeny ------------------------------ */
  function initMobileNav() {
    var nav = document.querySelector("[data-mobile-nav]");
    var openBtn = document.querySelector("[data-mobile-nav-open]");
    var closeBtn = document.querySelector("[data-mobile-nav-close]");
    if (!nav || !openBtn) return;
    function open() { nav.dataset.open = "true"; document.body.style.overflow = "hidden"; }
    function close() { nav.dataset.open = "false"; document.body.style.overflow = ""; }
    openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    var backdrop = nav.querySelector(".mobile-nav__backdrop");
    if (backdrop) backdrop.addEventListener("click", close);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });

    nav.querySelectorAll("[data-mobile-nav-toggle]").forEach(function (toggle) {
      var submenu = toggle.nextElementSibling;
      if (!submenu) return;
      toggle.addEventListener("click", function () {
        var expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!expanded));
        submenu.style.maxHeight = expanded ? "0px" : submenu.scrollHeight + "px";
      });
    });

    var searchOpen = nav.querySelector("[data-search-open]");
    if (searchOpen) searchOpen.addEventListener("click", close);
  }

  /* -------------------------------- FAQ ------------------------------------ */
  function initFaq() {
    document.querySelectorAll(".faq-item__q").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var expanded = btn.getAttribute("aria-expanded") === "true";
        var answer = document.getElementById(btn.getAttribute("aria-controls"));
        btn.setAttribute("aria-expanded", String(!expanded));
        if (answer) {
          answer.style.maxHeight = expanded ? "0px" : answer.scrollHeight + "px";
        }
      });
    });
  }

  /* --------------------------- Omdömeskarusell ------------------------------ */
  function initReviewNav() {
    document.querySelectorAll("[data-review-track]").forEach(function (track) {
      var wrapper = track.closest("[data-reviews]");
      if (!wrapper) return;
      var prev = wrapper.querySelector("[data-review-prev]");
      var next = wrapper.querySelector("[data-review-next]");
      var scrollAmount = function () {
        var card = track.querySelector(".review-card");
        return card ? card.getBoundingClientRect().width + 24 : 320;
      };
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -scrollAmount(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: scrollAmount(), behavior: "smooth" }); });
    });
  }

  /* --------------------------- Relaterade produkter --------------------------- */
  function initProductRecommendations() {
    var section = document.querySelector('[data-section-type="product-recommendations"]');
    if (!section) return;
    var url = section.dataset.url;
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newSection = doc.querySelector('[data-section-type="product-recommendations"]');
        if (newSection && newSection.querySelector(".product-card")) {
          section.innerHTML = newSection.innerHTML;
          // Content injected after the page's scroll-reveal observer already
          // ran its initial scan, so these [data-reveal] elements would
          // otherwise stay permanently hidden — show them immediately instead.
          section.querySelectorAll("[data-reveal]").forEach(function (el) {
            el.classList.add("is-visible");
          });
        } else {
          section.remove();
        }
      })
      .catch(function () {});
  }

  /* ------------------------------ Produktgalleri ---------------------------- */
  function initGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var mainImg = gallery.querySelector("[data-main-image]");
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-thumb]"));
      var swipeHint = gallery.querySelector("[data-swipe-hint]");
      if (!mainImg || !thumbs.length) return;

      function selectThumb(thumb) {
        if (!thumb) return;
        /* The main image has a srcset for responsive loading — if it's
           left in place, the browser keeps using it and ignores the new
           src entirely, so the click silently does nothing. */
        mainImg.removeAttribute("srcset");
        mainImg.removeAttribute("sizes");
        mainImg.src = thumb.dataset.fullSrc || thumb.querySelector("img").src;
        thumbs.forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
        if (swipeHint) swipeHint.classList.add("is-hidden");
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () { selectThumb(thumb); });
      });

      /* Swipe between images on mobile only — desktop shoppers already
         have the thumbnail row for that. */
      var mainWrap = gallery.querySelector(".product__main-image");
      if (mainWrap && thumbs.length > 1) {
        var touchStartX = null;
        var touchStartY = null;
        mainWrap.addEventListener("touchstart", function (e) {
          if (window.innerWidth > 900) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        mainWrap.addEventListener("touchend", function (e) {
          if (touchStartX === null || window.innerWidth > 900) return;
          var deltaX = e.changedTouches[0].clientX - touchStartX;
          var deltaY = e.changedTouches[0].clientY - touchStartY;
          touchStartX = null;
          touchStartY = null;
          /* Ignore small taps and mostly-vertical scrolls. */
          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          var currentIndex = thumbs.findIndex(function (t) { return t.getAttribute("aria-current") === "true"; });
          if (currentIndex === -1) currentIndex = 0;
          var nextIndex = deltaX < 0
            ? (currentIndex + 1) % thumbs.length
            : (currentIndex - 1 + thumbs.length) % thumbs.length;
          selectThumb(thumbs[nextIndex]);
        }, { passive: true });
      }
    });
  }

  /* ------------------------------- Variantväljare ----------------------------- */
  function initVariantPicker() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var wrapper = form.closest(".product");
      if (!wrapper) return;
      var variantsScript = wrapper.querySelector("[data-product-variants]");
      if (!variantsScript) return;
      var variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }

      var idInput = form.querySelector('input[name="id"]');
      var priceEl = wrapper.querySelector("[data-product-price]");
      var addBtn = form.querySelector(".product__buy-buttons button[type=submit]");
      var mainImg = wrapper.querySelector("[data-main-image]");
      var optionGroups = form.querySelectorAll(".variant-picker");
      var stickyPrice = document.querySelector(".sticky-atc-inner__price");

      function money(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
          style: "currency",
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR",
        });
      }

      function getSelectedOptions() {
        var selected = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('.variant-option[aria-pressed="true"]');
          selected.push(active ? active.dataset.optionValue : null);
        });
        return selected;
      }

      function findVariant(selected) {
        return variants.filter(function (variant) {
          return variant.options.every(function (value, i) { return value === selected[i]; });
        })[0];
      }

      function updateUI(variant) {
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          var html = "";
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += "<s>" + money(variant.compare_at_price) + "</s> ";
          }
          html += money(variant.price);
          priceEl.innerHTML = html;
        }
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? kvt("add_to_cart","Add to cart") : kvt("sold_out","Sold out");
        }
        if (mainImg && variant.featured_image && variant.featured_image.src) {
          mainImg.removeAttribute("srcset");
          mainImg.removeAttribute("sizes");
          mainImg.src = variant.featured_image.src;
        }
      }

      optionGroups.forEach(function (group) {
        group.querySelectorAll(".variant-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            group.querySelectorAll(".variant-option").forEach(function (b) {
              b.setAttribute("aria-pressed", "false");
            });
            btn.setAttribute("aria-pressed", "true");
            updateUI(findVariant(getSelectedOptions()));
          });
        });
      });
    });
  }

  /* --------------------------- Antal-väljare (kvantitet) --------------------- */
  function initQuantity() {
    document.querySelectorAll("[data-quantity-selector]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector("[data-quantity-minus]");
      var plus = wrap.querySelector("[data-quantity-plus]");
      if (!input) return;
      function setVal(v) {
        v = Math.max(1, v);
        input.value = v;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      if (minus) minus.addEventListener("click", function () { setVal(parseInt(input.value || "1", 10) - 1); });
      if (plus) plus.addEventListener("click", function () { setVal(parseInt(input.value || "1", 10) + 1); });
    });
  }

  /* --------------------------- Sticky add-to-cart --------------------------- */
  function initStickyAtc() {
    var sticky = document.querySelector("[data-sticky-atc]");
    var trigger = document.querySelector("[data-sticky-atc-trigger]");
    if (!sticky || !trigger || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.dataset.visible = String(!entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  }

  /* --------------------------------- Mega-meny -------------------------------- */
  function initMegaMenu() {
    var items = document.querySelectorAll(".main-nav__item[data-has-dropdown]");
    if (!items.length) return;
    items.forEach(function (item) {
      var link = item.querySelector(":scope > a");
      if (!link) return;
      link.addEventListener("click", function (e) {
        if (window.innerWidth <= 900) return;
        e.preventDefault();
        var isOpen = item.dataset.open === "true";
        items.forEach(function (i) { i.dataset.open = "false"; });
        item.dataset.open = String(!isOpen);
      });
    });
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".main-nav__item")) {
        items.forEach(function (i) { i.dataset.open = "false"; });
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") items.forEach(function (i) { i.dataset.open = "false"; });
    });
  }

  /* ---------------------------- Announcement bar ----------------------------- */
  function initAnnouncementBar() {
    document.querySelectorAll("[data-announcement-track]").forEach(function (track) {
      var items = track.querySelectorAll(".announcement-bar__item");
      if (items.length < 2) return;
      var bar = track.closest(".announcement-bar");
      var seconds = parseInt((bar && bar.dataset.rotateSeconds) || "5", 10);
      var index = 0;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      setInterval(function () {
        items[index].hidden = true;
        index = (index + 1) % items.length;
        items[index].hidden = false;
      }, Math.max(3, seconds) * 1000);
    });
  }

  /* ----------------------------- Hero-bakgrundsvideo ------------------------- */
  function initHeroVideo() {
    var video = document.querySelector(".hero__bg-video");
    if (!video) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.pause();
      video.removeAttribute("autoplay");
    }
  }

  /* ------------------------------- Loading reveal ------------------------------ */
  function initLoadingReveal() {
    var stages = document.querySelectorAll("[data-loading-reveal]");
    if (!stages.length) return;

    var LOAD_MS = 1400;
    var HEX = "0123456789ABCDEF";

    function runLoader(stage) {
      var fill = stage.querySelector("[data-loader-fill]");
      var code = stage.querySelector("[data-loader-code]");
      var codeTimer = null;

      if (code) {
        var chars = 42;
        codeTimer = window.setInterval(function () {
          var out = "";
          for (var i = 0; i < chars; i++) out += HEX.charAt(Math.floor(Math.random() * HEX.length));
          code.textContent = out;
        }, 55);
      }
      // Trigger the width transition on the next frame so it actually animates.
      window.requestAnimationFrame(function () {
        if (fill) fill.style.width = "100%";
      });
      window.setTimeout(function () {
        if (codeTimer) window.clearInterval(codeTimer);
        stage.setAttribute("data-loaded", "true");
      }, LOAD_MS);
    }

    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      stages.forEach(function (stage) { stage.setAttribute("data-loaded", "true"); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runLoader(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    stages.forEach(function (stage) { observer.observe(stage); });
  }

  /* ------------------------------ Tilt-kort (curated) ------------------------- */
  function initTiltCards() {
    var cards = document.querySelectorAll("[data-tilt]");
    if (!cards.length) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (!window.matchMedia || !window.matchMedia("(pointer: fine)").matches) return;

    cards.forEach(function (card) {
      var media = card.querySelector("[data-tilt-media]");
      if (!media) return;
      var raf = null;

      function onMove(e) {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var rect = card.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          var y = (e.clientY - rect.top) / rect.height - 0.5;
          media.style.transform =
            "perspective(900px) rotateX(" + (y * -7) + "deg) rotateY(" + (x * 7) + "deg) translateY(-8px)";
        });
      }
      function onEnter() {
        card.setAttribute("data-tilt-active", "true");
      }
      function onLeave() {
        card.removeAttribute("data-tilt-active");
        media.style.transform = "";
      }
      card.addEventListener("pointerenter", onEnter);
      card.addEventListener("pointermove", onMove);
      card.addEventListener("pointerleave", onLeave);
    });
  }

  /* -------------------------- Språkväljare (T Lab) ------------------------- */
  /* The T Lab translation app injects its own language switcher as a fixed,
     top-right overlay appended straight to <body> — it has no idea our
     header even exists. Move it into .header-actions as soon as it shows
     up so it sits inline with the other icons (left of account/cart/menu)
     instead of floating in the corner. It can arrive at any time after
     load, so a MutationObserver is used instead of a fixed delay. */
  function initLanguageSwitcherPosition() {
    var actions = document.querySelector(".header-actions");
    if (!actions) return;

    function place(el) {
      if (el.parentElement !== actions) {
        actions.insertBefore(el, actions.firstChild);
      }
    }

    var existing = document.querySelector(".tl-switcher-container");
    if (existing) {
      place(existing);
      return;
    }

    var observer = new MutationObserver(function () {
      var el = document.querySelector(".tl-switcher-container");
      if (el) {
        place(el);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* Any URL a merchant types by hand into a section setting (a button
     link, a CTA, etc.) is stored as a plain path like "/collections/all"
     — Shopify never rewrites that to "/de/collections/all" for you, so
     clicking it silently drops the visitor back to the default language
     mid-browse. This rewrites those links to carry whichever language
     prefix is currently active, using the real language codes T Lab
     renders rather than a guessed list. Runs once for links already on
     the page, then keeps watching for ones added later (cart drawer,
     quick view, mega menu, etc.). */
  function initLocaleLinkFix() {
    var pathLocale = location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    if (!pathLocale) return;
    var prefix = "/" + pathLocale[1];
    var neverPrefix = /^\/(cart|checkout|account|search|apps|cdn|admin)(\/|$)/;

    function knownLocales() {
      var codes = Array.prototype.map.call(
        document.querySelectorAll(".tl-option[data-value]"),
        function (el) { return el.getAttribute("data-value"); }
      );
      return codes.length ? codes : ["de", "es", "it", "pl", "sk", "nl"];
    }

    function fixLinks() {
      var locales = knownLocales();
      if (locales.indexOf(pathLocale[1]) === -1) return;
      document.querySelectorAll('a[href^="/"]').forEach(function (a) {
        var href = a.getAttribute("href");
        if (href === prefix || href.indexOf(prefix + "/") === 0) return;
        if (neverPrefix.test(href)) return;
        var alreadyLocalized = href.match(/^\/([a-z]{2})(\/|$)/);
        if (alreadyLocalized && locales.indexOf(alreadyLocalized[1]) !== -1) return;
        a.setAttribute("href", prefix + href);
      });
    }

    fixLinks();
    var observer = new MutationObserver(fixLinks);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initAll() {
    initMobileNav();
    initFaq();
    initReviewNav();
    initProductRecommendations();
    initGallery();
    initVariantPicker();
    initQuantity();
    initStickyAtc();
    initMegaMenu();
    initAnnouncementBar();
    initHeroVideo();
    initLoadingReveal();
    initTiltCards();
    initLanguageSwitcherPosition();
    initLocaleLinkFix();
  }


  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
